/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Strength_E1rm_HintInputs */

const en_us2_exercise_personal_strength_e1rm_hint = /** @type {(inputs: Exercise_Personal_Strength_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The weight you could lift once, worked out from your sets.`)
};

const pt_br2_exercise_personal_strength_e1rm_hint = /** @type {(inputs: Exercise_Personal_Strength_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O peso que você conseguiria levantar uma única vez, calculado pelas suas séries.`)
};

const es_419_exercise_personal_strength_e1rm_hint = /** @type {(inputs: Exercise_Personal_Strength_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El peso que podrías levantar una sola vez, calculado a partir de tus series.`)
};

const pt_pt2_exercise_personal_strength_e1rm_hint = /** @type {(inputs: Exercise_Personal_Strength_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O peso que conseguirias levantar uma única vez, calculado a partir das tuas séries.`)
};

const fr_fr2_exercise_personal_strength_e1rm_hint = /** @type {(inputs: Exercise_Personal_Strength_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La charge que tu pourrais soulever une seule fois, calculée à partir de tes séries.`)
};

const de_de2_exercise_personal_strength_e1rm_hint = /** @type {(inputs: Exercise_Personal_Strength_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Gewicht, das du einmal heben könntest, berechnet aus deinen Sätzen.`)
};

const it_it2_exercise_personal_strength_e1rm_hint = /** @type {(inputs: Exercise_Personal_Strength_E1rm_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il peso che potresti sollevare una sola volta, calcolato dalle tue serie.`)
};

/**
* | output |
* | --- |
* | "The weight you could lift once, worked out from your sets." |
*
* @param {Exercise_Personal_Strength_E1rm_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_strength_e1rm_hint = /** @type {((inputs?: Exercise_Personal_Strength_E1rm_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Strength_E1rm_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_strength_e1rm_hint(inputs)
	if (locale === "es-419") return es_419_exercise_personal_strength_e1rm_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_strength_e1rm_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_strength_e1rm_hint(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_strength_e1rm_hint(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_strength_e1rm_hint(inputs)
	return en_us2_exercise_personal_strength_e1rm_hint(inputs)
});
export { exercise_personal_strength_e1rm_hint as "exercise-personal.strength_e1rm_hint" }